export default {
  setItems(state, payload) {
    state.items = payload;
  },
  setIndex(state, payload) {
    state.index = payload;
  },
};
